<template>
    <div class="organization_member">
        <div v-wechat-title="$route.meta.title"></div>
        <!--Topbar></Topbar-->
        <div>		
            <!-- 组织栏 -->
			<OrgTree ref="department"  @getMemberList="getMemberList" @loadData="loadData" :department="department" :memberList="memberList" :roleList="roleList":departmentList="departmentList"></OrgTree>
            <!--Tissue ref="department" :teamList="teamList" :logList="logList" @getMemberList="getMemberList" @loadData="loadData" :departmentList="departmentList"></Tissue-->
            <!-- 成员列表 -->
            <!--MemberList :department="department" :memberList="memberList" :departmentList="departmentList" @getMemberList="getMemberList" :roleList="roleList"></MemberList-->
        </div>

    </div>
</template>
<script>
    import {
        getRoleList,getDepartmentList,getDepartmentLog,getMemberByDepartment,getDepartmentTree
    } from '@/api/user'
    import {mapGetters, mapActions} from 'vuex';
    import Tissue from "./Tissue.vue"
	import OrgTree from "./OrgTree.vue"
    import MemberList from "./MemberList.vue"
    import Topbar from '../topbar/TopBar.vue'

    export default {
        name: "OrganizationMember",
        components: {Tissue, MemberList, Topbar,OrgTree},
        data() {
            return {
                roleList: [],
                departmentList: [],
				departmentTree:[],
                memberList: [],
                logList: [],
				teamList:[],
                department: 0
            }
        },
        computed: {
            ...mapGetters(['token'])
        },
        mounted: function () {
            this.loadData();
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
            async loadData() {
                let that = this;
                let data = {token: this.token, getSelf: 1};
                var res = await getDepartmentList(that, data);
				/*
				var res1 = await getDepartmentTree(that, data);
				that.departmentTree = res1.data.list;//树形组织结构
				*/
                if (res.code == 1) {
					that.departmentList = res.data.list;
                    that.department = res.data.list[0].id
                    that.$refs['department'].activeId = res.data.list[0].id
                    that.getMemberList();
                }
                var res = await getRoleList(that, data);
                if (res.code == 1) {
                    that.roleList = res.data.list;
                }
                var res = await getDepartmentLog(that, data);
                that.logList = res.data.list;
            },
            async getMemberList() {	
                let that = this;
                let data = {token: this.token};
                that.department = that.$refs['department'].activeId;
                data.id = that.$refs['department'].activeId;
                let res = await getMemberByDepartment(that, data);
                if (res.code == 1) {
                    that.memberList = res.data.list;
					
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .organization_member {
       min-width: 1900px;
		min-height: 100%;
        background-color: #F5F7F9;
    }
</style>
